import styled from 'styled-components'
import { collapsedLeftContainerWidth } from '~/constants'

export const Content = styled.div`
  position: relative;
  height: 100%;

  display: flex;
  overflow: hidden;
`

interface IProps {
  leftWidth: string
}

export const LeftContainer = styled.div<IProps>`
  position: relative;
  width: ${({ leftWidth }) => leftWidth};
  height: 100%;
  border-right: 1px solid ${props => props.theme.colors.colore9ecf3};

  background-color: ${props => props.theme.colors.colorf3f5f9};
  transition: width 0.3s ease-in-out;
  z-index: 10;

  display: flex;
  flex-direction: column;
  justify-content: space-between;
`

export const InfoContainer = styled.div`
  position: relative;
  display: contents;
`

export const ChevronButtonContainer = styled.div<IProps>`
  position: relative;
  margin-right: ${({ leftWidth }) => (leftWidth === collapsedLeftContainerWidth ? '0rem' : '1rem')};
  margin-bottom: 10px;
  align-self: ${({ leftWidth }) => (leftWidth === collapsedLeftContainerWidth ? 'center' : 'end')};
  transition-delay: ${({ leftWidth }) => (leftWidth === collapsedLeftContainerWidth ? '0.2s' : '0s')};
`
